'use strict';

/* global yith_wcaf */

import YITH_WCAF_Admin_Actions_Table from './yith-wcaf-admin-actions-table';
import YITH_WCAF_Add_Profile_Field_Modal from './yith-wcaf-add-profile-field-modal';

export default class YITH_WCAF_Profile_Fields_Table extends YITH_WCAF_Admin_Actions_Table {
	constructor( $context, args ) {
		super( $context, {
			action_suffix: '_affiliate_profile_field',
			nonce_suffix: '_profile_field',
			data: ( $row ) => {
				return {
					field_name: $row.data( 'id' ),
				};
			},
			...args,
		} );
	}

	initModal() {
		const $openers = this.getModalOpeners();

		if ( $openers.length ) {
			this.modal = new YITH_WCAF_Add_Profile_Field_Modal( $openers, {
				onSubmitSuccess: ( data ) => {
					if ( ! data?.template ) {
						return;
					}

					this.replaceTable( data?.template );
				},
			} );
		}
	}
}
